// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2BOO6","content":"LayoutSettings_content__27HrM"};